<template>
  <div id="aiben">
    <!-- 头部搜索 -->
    <userCardSearch :babyDays="babyDays" :babyInfo="babyInfo" :currentBabyInfo="currentBabyInfo" :editFlag="isEditFlag"
      :loginFlag="!isLoginFlag" currentPath="aiBenHome" @getSwitchBaby="getSwitchBaby">
    </userCardSearch>

    <!-- 用户信息 -->
    <div class="user-message">
      <div class="user-info-wrapper">
        <div class="user-info">您好<span v-if="isEditAiben">, {{ username }}</span>
        </div>
        <div class="tips">健康检测，健康状态时刻掌握</div>
        <div class="healthy-do" @click="jumpLink('健康检测')">健康检测</div>
      </div>
      <radar-Map class="user-data"></radar-Map>
    </div>
    <div class="healthy-note">
      <div class="healthy-note-wrapper">
        <img src="../../assets/images/aiben/test-note.png" alt="" />
        <div @click="jumpLink('检测记录')">检测记录</div>
      </div>
    </div>
    <!-- 金刚位 -->
    <tab @jumpLink="jumpLink" />
    <!-- 视频轮播 -->
    <van-swipe :autoplay="3000" v-if="images.length > 0" @change="senors">
      <van-swipe-item v-for="(image, index) in images" :key="index" class="banner-item" @click="playVideo(image, true)"
        :data="JSON.stringify(image)">
        <img v-lazy="image.imgUrl" />
        <div class="play-icon"></div>
      </van-swipe-item>
    </van-swipe>
    <!-- 内容数据 - tab标签-->
    <van-tabs v-if="tabTag.length > 0" v-model="active" title-inactive-color="#333333" @click="updateTab">
      <van-tab v-for="(item, index) in tabTag" :key="index" :name="item.id" :title="item.name">
      </van-tab>
    </van-tabs>
    <!-- 内容数据 - 文章 -->
    <van-list :offset="10" v-model="loadingParams.loading" :finished="loadingParams.finished"
      :finished-text="loadingParams.finishedText" :error.sync="loadingParams.error" @load="getArticle"
      :immediate-check="false" v-if="contentList.length > 0">
      <div v-for="(item, index) in contentList" :key="index" class="content-wrapper" :data="JSON.stringify(item)">
        <div v-if="item.type === 2" class="video-wrapper" @click="playVideo(item, false)">
          <div class="video-title">{{ item.videoTitle }}</div>
          <div class="video-imgurl" :style="{ backgroundImage: 'url(' + item.videoImageUrl + ')' }">
            <div class="play-icon"></div>
          </div>
        </div>
        <div v-if="item.type === 0" class="article-wrapper" @click="jumpDetail(item)">
          <div class="article-title-wrapper">
            <div class="artcile-title">{{ item.contentTitle }}</div>
            <div class="article-handle">
              <div class="look-article artice-handle name">
                <img src="../../assets/images/aiben/look.png" alt="" />
                <span>{{ fomatterNum(item.watchNum,false) }}</span>
              </div>
              <div class="like-article artice-handle name" @click.stop="addCollect(item)">
                <img :src="
                  item.collectStatus === 1
                    ? require('../../assets/images/aiben/like-active.png')
                    : require('../../assets/images/aiben/like.png')
                " alt="" />
                <span>{{ fomatterNum(item.collectNum,false) }}</span>
              </div>
              <div class="collect-article artice-handle name">
                <img src="../../assets/images/aiben/speak.png" alt="" />
                <span>{{ fomatterNum(item.commentNum, false) }}</span>
              </div>
            </div>
          </div>
          <div class="artcile-imgurl" :style="{ backgroundImage: 'url(' + item.contentImageUrl + ')' }"></div>
        </div>
      </div>
    </van-list>
    <!-- 视频播放 -->
    <foodVedio ref="childVideo" :showVedio="showVideo" :videoDetail="doctorInfo" :videoId="doctorInfo.id"
      getContainer="#HorizontalScreen" isHfindex="true" :isShowComment="true" @hideVedio="hideVideoEvent" />
  </div>
</template>

<script>
import { isUserEdit, isUserLogin, getCookie, getUserInfo, throttle, fomatterNum, Debounce, browsTime  } from "@/assets/js/common.js";
import API from "../../utils/axiosApi/aibenApi";
import {
  Exposurer_aiben_Fn,
  BuiedPointClick_Fn,
  aibenClick_Fn
} from "../../assets/js/BuriedPointEvent.js";
// 组件
import tab from "./components/tab.vue";
import userCardSearch from "@/components/home/userCardSearch/index.vue"; // 用户卡片
import radarMap from "@/components/aiben/radarMap.vue";
import foodVedio from "@/views/contents/bjfamousdoctor/component/video.vue"; //京城名医视频播放

var timestamp = new Date().getTime();
export default {
  name: "aiBenHome",
  components: {
    tab,
    userCardSearch,
    radarMap,
    foodVedio,
  },
  data() {
    return {
      images: [],
      tabTag: [],
      active: 0,
      babyDays: {},
      babyInfo: [],
      currentBabyInfo: [],
      isEditFlag: false, // 是否定制
      isLoginFlag: true, // 是否登陆
      contentList: [],
      loadingParams: {
        loading: false,
        finished: false,
        error: false,
        finishedText: "",
        pageSize: 10,
        pageNum: 1,
      },
      username: "",
      isEditAiben: false, // 是否定制爱本信息
      showVideo: false, // 视频展示状态
      tagId: "", // 标签id
      doctorInfo: {}, // 视频信息
      saveParams: {}, // 埋点数据
      currentClassifyName: '', // 当前选中的分类的name
      timer: null,
      duration: 0,
      itemId: '',
    };
  },
  watch:{
    $route: {
      immediate: true,
      handler(to, from) {
        if (to.name == "aiBenHome") this.startTimer()
      }
    }
  },
  methods: {
    fomatterNum,
    startTimer() {
      this.timer = setInterval(() => {
        this.duration++
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    beforeunloadHandler () {
      this.stopTimer()
    },
    getSwitchBaby(data) {
      this.$router.replace({
        path: "/home?source=edit",
      });
    },
    // 定制爱本信息
     getAibenEditInfo() {
      API.isEditAibenMessage(
        {},
        {
          memberId: this.$route.query.crmId || getUserInfo(),
          unionId: getCookie('xmh_unionid')
        },
        (res) => {
          if (res.code == 200) {
            this.isEditAiben = res.data !== "该用户未定制";
            this.username = res.data.name;
            this.saveParams = {
              xmh_aibenh5_dingzhi_state: this.isEditAiben,
              xmh_aibenh5_dingzhi_gender: res.data.sex === 0 ? '女' : '男' || "",
              xmh_aibenh5_dingzhi_age: res.data.ageStage || "",
              xmh_aibenh5_dingzhi_city: res.data.province + res.data.city || "",
            };
            aibenClick_Fn("xmh_aibenh5_home_view");
            this.isEditAiben && localStorage.setItem("aibenMessage", JSON.stringify(res.data));
          }else{
            this.isEditAiben = false
            this.$toast("系统异常，请稍后再试！")
          }
        }
      );
    },
    // 视频播放返回按钮
    hideVideoEvent() {
      this.showVideo = false;
    },
    // 初次加载数据
    getArticle: throttle(function () {
      const params = {
        pageSize: this.loadingParams.pageSize,
        pageNum: this.loadingParams.pageNum,
        crmId: this.$route.query.crmId || getUserInfo(),
        tagId: this.tagId,
      };
      API.getContentData({}, params, (res) => {
        if (res.code == 200) {
          const { total, data } = res.data;
          if (this.loadingParams.pageNum === 1) {
            this.contentList = data;
          } else {
            this.contentList = [...this.contentList, ...data];
          }
          this.currentClassifyName = this.tabTag.filter((item)=> this.active === item.id)[0].name
          this.$nextTick(() => {
            Exposurer_aiben_Fn.observe(
              "xmh_aibenh5_home_content_view",
              ".content-wrapper",
              false,
              {
                ...this.saveParams,
                xmh_aibenh5_content_classes: this.active > 0 ? this.currentClassifyName : '',
              }
            );
          }, 200);
          if (
            this.loadingParams.pageNum * this.loadingParams.pageSize >=
            total
          ) {
            this.loadingParams.finished = true;
            this.loadingParams.finishedText = "已经加载到底啦";
          } else {
            this.loadingParams.pageNum += 1;
            this.loadingParams.loading = false;
          }
        } else {
          this.$toast("网络异常");
          this.loadingParams.loading = false;
          this.loadingParams.error = true;
        }
      });
    },200),
    updateTab(value) {
      this.loadingParams.pageNum = 1;
      this.loadingParams.loading = false;
      this.tagId = value;
      this.getArticle();
    },
    // banner列表
    getBanner() {
      API.getBanner({}, { columnId: 13 }, (res) => {
        if (res.code == 200) {
          this.images = res.data;
        }
      });
    },
    // 轮播曝光
    senors(index){
      aibenClick_Fn("xmh_aibenh5_home_banner_view", {
        xmh_aibenh5_home_banner_name: this.images[index].title
      });
    },
    // tab列表
    getTabList() {
      API.getTabList({}, (res) => {
        if (res.code == 200) {
          this.tabTag = res.data;
          this.tagId = res.data[0].id;
          this.getArticle(); // 文章列表
        }
      });
    },
    // 跳转到第三方
    jumpLink: Debounce(function (type) {
      // 埋点
      aibenClick_Fn("xmh_aibenh5_home_elements_click", {
        xmh_aibenh5_elements_name: type,
      });
      setTimeout(()=>{
      switch (type) {
        case "健康检测":
          this.$router.push({
            path: "/lineDoctor",
            query: { toUrlSource: "10", utm_campaign: "aibenHome" },
          });
          break;
        case "检测记录":
          this.$router.push({
            path: "/lineDoctor",
            query: { toUrlSource: "11", utm_campaign: "aibenHome" },
          });
          break;
        case "急速问诊":
          this.$router.push({
            path: "/lineDoctor",
            query: { utm_campaign: "aibenHome" },
          });
          break;
        case "吃出健康":
          this.$router.push("/abEat");
          break;
        case "会员权益":
          location.href =
            location.origin + "/member/mine/vipPrivilege?source=adultPowderH5";
          break;
        // 跳转到会员权益
        case "扫码积分":
          this.wxJsSet.wxScan();
          break;
        case "正品溯源":
          let head = this.$http.hostName == "https://mom.feihe.com" ?  'https://wic.feihe.com' :  "https://wicuat.feihe.com"
          const crmId = this.$route.query.crmId || getUserInfo()
          location.href = head + `/review/front/review/sweep?source=${crmId}&target=26`;
          break;
      }
    },200)
      if(type == '正品溯源' || type == '会员权益') {
        var time = browsTime(timestamp)
        timestamp = new Date().getTime()
          aibenClick_Fn("xmh_aibenh5_visititime", {
            xmh_aibenh5_view_time: time + 's'
          })
      }
    }),
    // 金刚位跳转
    // status 是否要转换字段
    playVideo(val, status) {
      this.showVideo = true;
      val.name = status ? val.title : val.videoTitle;
      this.doctorInfo = {
        ...val,
        contentPayUrl: val.contentUrl || val.videoUrl
      };
      console.log(val)
      let params = {};
      let eventName = '';
      params = status
        ? { xmh_aibenh5_home_banner_name: val.title }
        : {
          xmh_aibenh5_content_type: "视频",
          xmh_aibenh5_content_title: val.videoTitle,
          xmh_aibenh5_content_classes: this.currentClassifyName,
        };
      eventName = status ? "xmh_aibenh5_home_banner_click" : "xmh_aibenh5_home_content_click"
      BuiedPointClick_Fn(eventName, Object.assign(this.saveParams, params));
    },
    // 跳转到文章详情页
    jumpDetail: Debounce(function (item) {
      BuiedPointClick_Fn("xmh_aibenh5_home_content_click", {
        ...this.saveParams,
        xmh_aibenh5_content_type: "文章",
        xmh_aibenh5_content_title: item.contentTitle,
        xmh_aibenh5_content_classes: this.currentClassifyName,
      });
      this.itemId = item.contentId
      var that = this;
      setTimeout(function () {
        that.$router.push({
          path: "/baby/detail/" + item.contentId + "?source=home",
        });
        var time = browsTime(timestamp)
        timestamp = new Date().getTime()
        aibenClick_Fn("xmh_aibenh5_visititime", {
          xmh_aibenh5_view_time: time + 's'
        })
        that.$store.commit("changeIncludes", ["aiBenHome"]);
      }, 200);
    }),
    // 收藏文章
    addCollect: Debounce(function (item) {
      if (item.collectStatus === 1) {
        this.$http.post(
          "/content/operation/event",{},
          {
            crmId: this.$route.query.crmId || getUserInfo(),
            itemId: item.contentId,
            type: 1,
            actionType:1
          },
          (res) => {
            if (res.code == 200) {
              item.collectStatus = 0;
              item.collectNum -= 1;
            }
          },
          (err) =>{},
          "lucky"
        );
      } else {
        this.$http.post(
          "/content/operation/event",{},
          {
            crmId: this.$route.query.crmId || getUserInfo(),
            itemId: item.contentId,
            type:0,
            actionType:1
          },
          (res) => {
            if (res.code == 200) {
              item.collectStatus = 1;
              item.collectNum += 1;
            }
          },
          (err)=>{},
          'lucky'
        );
      }
    }),
  },
  created() {
    this.isLoginFlag = isUserLogin();
    this.isEditFlag = isUserEdit();
    this.babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
    this.babyDays = localStorage.getItem("babyTimes");
    this.getAibenEditInfo(); //获取爱本定制信息
    this.getTabList(); // tab
    this.getBanner(); // 视频banner
  },
   mounted() {
    this.wxJsSet.wxShare()
    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e))
  },
  destroyed() {
    BuiedPointClick_Fn("xmh_aibenh5_visititime", {...this.saveParams, xmh_aibenh5_view_time: this.duration + 's'});
    this.beforeunloadHandler()
  },
  activated(){
    if(this.$store.state.handledata !== ''){
      this.contentList.forEach((item)=>{
        if(this.itemId === item.contentId ){
          item.collectStatus = this.$store.state.handledata
          item.collectNum = this.$store.state.handledata === 0 ? item.collectNum - 1 : item.collectNum + 1
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import './aiBenHome.less';
</style>
